<script>
import ModalCloseButton from './ModalCloseButton';

export default {
  name: 'SignupModal',
  components: {
    ModalCloseButton,
  },
  props: {
    returnUrl: {
      type: String,
      default: '',
    },
  },
};
</script>

<template>
  <div class="signup-modal-wrap">
    <div class="signup-modal__header">
      <div class="signup-modal__title">Save Form Finder Preset?</div>
      <p
        class="signup-modal__text"
      >Sign up to be able to easily access the Form Finder settings that matter to you</p>
    </div>
    <div class="signup-modal__main">
      <a
        class="signup-modal__signup-btn"
        href="https://www.punters.com.au/register/"
        target="_blank"
      >Sign Up</a>
    </div>
    <div class="signup-modal__footer">
      Already have an account?
      <a
        :href="`/login/?ReturnUrl=${returnUrl}`"
        class="signup-modal__login-btn"
      >LOG IN</a>
    </div>
    <ModalCloseButton />
  </div>
</template>
